/** Content from mira_knowlage_base/software/mira-safe/риски-эйзенхауэр-таблицы.md — nothing else. */

export const ACTIONS_GUIDE_SECTIONS = [
  {
    id: '1',
    title: '#1 Устройство не на связи',
    lead: [
      'Прибор молчит. В компанию уходит старое показание с сервера — не «пусто».',
      'Смотрим только одно: сколько раз не ушла передача в компанию. Выходы «просто на связь» не считаем.',
    ],
    criterion: 'Сколько раз не ушла передача в компанию',
    rows: [
      ['0 — всё ушло', 'не пишем', 'не звоним'],
      ['1 раз', 'пишем жильцу', 'не звоним'],
      ['2 раза и больше', 'напоминаем', 'звоним'],
    ],
  },
  {
    id: '2',
    title: '#2 Показания не приняли',
    lead: [
      'День передачи наступил, а компания/портал не приняли показание. Прибор при этом может быть на связи.',
      'Смотрим только одно: почему не приняли.',
    ],
    criterion: 'Почему не приняли',
    rows: [
      [
        'Ошибка в данных жильца: не нашли счётчик / лицевой / квартиру / код плательщика, или неверный логин и пароль',
        'пишем: проверьте данные и доступы в личном кабинете',
        'не звоним',
      ],
      [
        'Мос.ру: больше 3 месяцев не вносили — передача заблокирована',
        'пишем: нужен акт через УК',
        'звоним',
      ],
    ],
  },
  {
    id: '3',
    title: '#3 Слабый сигнал',
    lead: [
      'Прибор на связи, но долго ловит сеть плохо. Один разовый провал не считаем. Совсем пропал — это уже #1, не этот риск.',
      'Смотрим только одно: насколько долго и плохо держится сигнал.',
    ],
    criterion: 'Сигнал',
    rows: [
      ['В норме', 'не пишем', 'не звоним'],
      ['Долго слабый', 'пишем: проверьте место установки и покрытие', 'не звоним'],
    ],
  },
  {
    id: '4',
    title: '#4 Батарея садится',
    lead: [
      'Батарея слабеет — меняем до полного обрыва. Связь ещё может быть.',
      'Смотрим два простых вопроса: насколько села батарея и на гарантии ли (меньше 6 мес. с установки — мы; дольше — жилец сам).',
    ],
    criterion: 'Батарея',
    rows: [
      ['В порядке', 'не пишем', 'не звоним'],
      ['Слабеет или почти села, гарантии нет', 'пишем: замените сами', 'не звоним'],
      ['Слабеет или почти села, на гарантии', 'пишем: заменим по гарантии', 'звоним'],
    ],
  },
];
